import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) { return ({
    root: {
        backgroundColor: '#fdfdff',
    },
    pageHeader: {
        marginRight: theme.spacing(3),
        display: 'flex',
    },
    pageIcon: {
        display: 'inline-block',
        color: '#3c44b1',
    },
    pageTitle: {
        paddingLeft: theme.spacing(2),
        '& .MuiTypography-h6': {
            fontWeight: 500,
            fontSize: '21px',
            color: '#212429',
        },
    },
}); });
var PageHeader = function (props) {
    var classes = useStyles();
    var title = props.title;
    return (React.createElement("div", { className: classes.pageHeader },
        React.createElement("div", { className: classes.pageTitle },
            React.createElement(Typography, { variant: "h6", component: "div" }, title))));
};
export default PageHeader;
//# sourceMappingURL=PageHeader.js.map